import { FilterViewItemActionType } from "@/models/quickFilter.model";

export const FILTER_VIEW_MENU_ITEMS = [
  {
    label: "Open in New Tab",
    value: FilterViewItemActionType.openInNewTab,
    icon: "icon-arrow-up-right-from-square",
    tooltip: "Open this View in a New Tab",
    bottomDivider: true,
  },
  {
    label: "Add to Folder",
    value: FilterViewItemActionType.move,
    icon: "icon-folder-plus",
    tooltip: "Move this View to the selected Folder",
    searchPlaceholder: "Search folders",
    hasSearch: true,
  },
  {
    label: "Rename",
    value: FilterViewItemActionType.rename,
    icon: "icon-pencil-outline",
    tooltip: "Rename this View",
  },
  {
    label: "Duplicate",
    value: FilterViewItemActionType.copy,
    icon: "icon-clone-outline",
    tooltip: "Create a copy of this View",
  },
  {
    label: "Remove from Folder",
    value: FilterViewItemActionType.removeFromFolder,
    icon: "icon-folder-xmark",
    tooltip: "Remove this View from the current Folder",
    disabled: true,
    bottomDivider: true,
  },
  {
    label: "Collapse all Folders",
    value: FilterViewItemActionType.collapseAll,
    icon: "icon-angles-up-down",
    tooltip: "Collapse all Folders",
  },
  {
    label: "Delete View",
    value: FilterViewItemActionType.remove,
    icon: "icon-trash-outline",
    tooltip: "Delete this View",
  }
];

export const FILTER_VIEW_FOLDER_MENU_ITEMS = [
  {
    label: "Rename",
    value: FilterViewItemActionType.rename,
    icon: "icon-pencil-outline",
    tooltip: "Rename this Folder",
    bottomDivider: true,
  },
  {
    label: "Collapse all Folders",
    value: FilterViewItemActionType.collapseAll,
    icon: "icon-angles-up-down",
    tooltip: "Collapse all Folders",
  },
  {
    label: "Delete Folder",
    value: FilterViewItemActionType.remove,
    icon: "icon-trash-outline",
    tooltip: "Delete this Folder",
  }
];